import { useActions } from '.'

const useReload = () => useActions().invalidatedQueries

export default useReload
